import CookieConsent from '../plugins/CookieConsent';

export default function initCookieConsent() {
  const ccc = new CookieConsent();

  return {
    ccc,
  };
}
